<mat-card>
  <mat-card-header>
    <mat-card-title>Gestión de {{ 'Comunidad' | translate}}</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching && item != null">

      <ng-container *ngIf="canEdit">

        <!--INFO GENERAL EDIT-->
        <form [formGroup]="formGroup">

          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos Generales
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="Center" *ngIf="!comunidadImageChanged()">
                <a target="_blank" href="{{item?.FotoPerfilUrl}}">
                  <img src="{{item?.FotoPerfilUrl}}" style="height: 100px; width: 100px; border-radius: 100%;">
                </a>
              </div>
              <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="Center" *ngIf="comunidadImageChanged()">
                <img src="{{comunidadImageBase64}}"
                  style="height: 100px; width: 100px; border-radius: 100%; margin-bottom: 10px;">
              </div>
              <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="Center">
                <button type="button" mat-raised-button [disabled]="isProcessing()" (click)="fileInput.click()">Cambiar
                  Imagen</button>
                <input hidden type="file" (change)="convertFileToBase64($event)" accept="image/*" #fileInput
                  color="primary">
              </div>

              <hr style="margin:20px 0px; width: 100%;">

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nombre*</mat-label>
                  <input matInput formControlName="Nombre" (keyup.enter)="onGuardar()" maxlength="200">
                  <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Tipo {{ 'Comunidad' | translate}}*</mat-label>
                  <mat-select formControlName="TipoComunidadId">
                    <mat-option *ngFor="let s of tipoComunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="!formGroup.controls['TipoComunidadId'].valid && formGroup.controls['TipoComunidadId'].touched">
                    {{ getErrorTipoComunidad() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isConsorcioSearching">{{ 'Consorcio' | translate}}*</mat-label>
                  <mat-label *ngIf="isConsorcioSearching">Cargando...</mat-label>
                  <mat-select formControlName="ConsorcioId">
                    <mat-option *ngFor="let s of consorcioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="!formGroup.controls['ConsorcioId'].valid && formGroup.controls['ConsorcioId'].touched">
                    {{ getErrorConsorcio() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Cantidad de Pisos</mat-label>
                  <input matInput formControlName="CantidadPisos" type="number" (keyup.enter)="onGuardar()">
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha Construcción</mat-label>
                  <input matInput [matDatepicker]="fechaConstruccionPicker" formControlName="FechaConstruccion"
                    (click)="fechaConstruccionPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaConstruccionPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle matSuffix (click)="clearDate('FechaConstruccion')">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaConstruccionPicker></mat-datepicker>
                </mat-form-field>
              </div>

              <div fxFlex=75 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Dirección</mat-label>
                  <input matInput formControlName="Direccion" (keyup.enter)="onGuardar()" maxlength="200">
                </mat-form-field>
              </div>
              <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Código Postal</mat-label>
                  <input matInput formControlName="CodigoPostal" (keyup.enter)="onGuardar()" maxlength="50">
                </mat-form-field>
              </div>

              <ng-container *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isCategoriaSuterhSearching">Categoría SUTERH</mat-label>
                    <mat-label *ngIf="isCategoriaSuterhSearching">Cargando...</mat-label>
                    <mat-select formControlName="CategoriaSuterhId">
                      <mat-option>Ninguna</mat-option>
                      <mat-option *ngFor="let s of categoriaSuterhList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Clave SUTERH</mat-label>
                    <input matInput formControlName="ClaveSuterh" (keyup.enter)="onGuardar()" maxlength="200">
                  </mat-form-field>
                </div>
              </ng-container>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Observaciones</mat-label>
                  <textarea matInput formControlName="Observaciones" (keyup.enter)="onGuardar()"
                    maxlength="300"></textarea>
                  <mat-error
                    *ngIf="!formGroup.controls['Observaciones'].valid && formGroup.controls['Observaciones'].touched">
                    {{ getErrorObservaciones() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <!--DATOS ESTRICTAMENTE DE OBRAS-->
              <ng-container *ngIf="tenantFeatureFlags?.HabilitarGestionObra">
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Contratista Principal*</mat-label>
                    <input matInput formControlName="ContratistaPrincipal" (keyup.enter)="onGuardar()" maxlength="200">
                    <mat-error
                      *ngIf="!formGroup.controls['ContratistaPrincipal'].valid && formGroup.controls['ContratistaPrincipal'].touched">
                      {{ getErrorContratistaPrincipal() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Ejecutiva de Obra*</mat-label>
                    <input matInput formControlName="EjecutivaObra" (keyup.enter)="onGuardar()" maxlength="200">
                    <mat-error
                      *ngIf="!formGroup.controls['EjecutivaObra'].valid && formGroup.controls['EjecutivaObra'].touched">
                      {{ getErrorEjecutivaObra() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>M<sup>2</sup> de {{'Comunidad' | translate}}*</mat-label>
                    <input matInput formControlName="M2Obra" type="number" (keyup.enter)="onGuardar()">
                    <mat-error
                      *ngIf="!formGroup.controls['M2Obra'].valid && formGroup.controls['M2Obra'].touched">
                      {{ getErrorM2Obra() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isTipoContratoSearching">Tipo de Contrato*</mat-label>
                    <mat-label *ngIf="isTipoContratoSearching">Cargando...</mat-label>
                    <mat-select formControlName="TipoContratoId">
                      <mat-option *ngFor="let s of comunidadTipoContratoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="!formGroup.controls['TipoContratoId'].valid && formGroup.controls['TipoContratoId'].touched">
                      {{ getErrorTipoContratoId() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Director de Obra*</mat-label>
                    <input matInput formControlName="DirectorObra" (keyup.enter)="onGuardar()" maxlength="200">
                    <mat-error
                      *ngIf="!formGroup.controls['DirectorObra'].valid && formGroup.controls['DirectorObra'].touched">
                      {{ getErrorDirectorObra() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Estudio Proyectista*</mat-label>
                    <input matInput formControlName="EstudioProyectista" (keyup.enter)="onGuardar()" maxlength="200">
                    <mat-error
                      *ngIf="!formGroup.controls['EstudioProyectista'].valid && formGroup.controls['EstudioProyectista'].touched">
                      {{ getErrorEstudioProyectista() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Estudio Calculista*</mat-label>
                    <input matInput formControlName="EstudioCalculista" (keyup.enter)="onGuardar()" maxlength="200">
                    <mat-error
                      *ngIf="!formGroup.controls['EstudioCalculista'].valid && formGroup.controls['EstudioCalculista'].touched">
                      {{ getErrorEstudioCalculista() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Representante Técnico*</mat-label>
                    <input matInput formControlName="RepresentanteTecnico" (keyup.enter)="onGuardar()" maxlength="200">
                    <mat-error
                      *ngIf="!formGroup.controls['RepresentanteTecnico'].valid && formGroup.controls['RepresentanteTecnico'].touched">
                      {{ getErrorRepresentanteTecnico() }}
                    </mat-error>
                  </mat-form-field>
                </div>
              </ng-container>

              <hr style="margin:20px 0px; width: 100%;">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="canViewPuntoEq">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Punto de Equilibrio</mat-label>
                  <input matInput type="number" formControlName="PuntoEquilibrio" (keyup.enter)="onGuardar()">
                </mat-form-field>
              </div>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column">
              <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
                <mat-checkbox [(ngModel)]="item.Activo" [ngModelOptions]="{standalone: true}"
                  (keyup.enter)="onGuardar()" color="primary">Activo</mat-checkbox>
              </div>
            </div>

          </mat-expansion-panel>

        </form>

        <!--ADJUNTOS EDIT-->
        <br/>
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">attach_file</mat-icon> Adjuntos
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" *ngFor="let file of item.Adjuntos" style="margin: 5px;">

            <div fxFlex=30 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Descripción</mat-label>
                <input matInput [(ngModel)]="file.Descripcion" maxlength="150">
              </mat-form-field>
            </div>
            <div fxFlex=65 fxFlex.xs=95 class="flex-item" style="margin-top: 20px;">
              <a matLine href="{{file.UrlDocumento}}" target="_blank">{{file.NombreDocumento}}</a>
            </div>
            <div fxFlex=5 fxFlex.xs=5 class="flex-item" style="margin-top: 10px;">
              <button mat-icon-button (click)="onFileAttachedDelete(file)" title="Eliminar adjunto">
                <i class="fa fa-trash fa-1x"></i>
              </button>
            </div>

          </div>

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=30 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Descripción</mat-label>
                <input matInput [(ngModel)]="newFileDescripcion">
              </mat-form-field>
            </div>
            <div fxFlex=70 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;">
              <button mat-icon-button matSuffix (click)="adjuntoInput.click()" [disabled]="isFileAttaching">
                <mat-icon style="margin-right: 5px;">attach_file</mat-icon> Agregar adjunto
              </button>
              <input hidden (change)="onNewFileAttach($event)" #adjuntoInput type="file">
              <mat-label *ngIf="isFileAttaching"><br /><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...
              </mat-label>
            </div>

          </div>

        </mat-expansion-panel>

        <!--USUARIOS EDIT-->
        <ng-container *ngIf="canUserEdit || canUserView">
          <br/>
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">lock_open</mat-icon> Usuarios Habilitados
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <form [formGroup]="formUsuarioGroup" *ngIf="canUserEdit">

              <div fxLayout="row stretch" fxLayout.xs="column">

                <div fxFlex=45 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isUsuarioAutocompleteSearching">Usuario*</mat-label>
                    <mat-label *ngIf="isUsuarioAutocompleteSearching">Cargando...</mat-label>
                    <input type="text" placeholder="Nickname de Usuario" aria-label="Nickname de Usuario" matInput
                      formControlName="Usuario" [matAutocomplete]="usuario">
                    <i [ngStyle]="{'display': isUsuarioAutocompleteSearching ? 'inline-block' : 'none'}"
                      class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                    <mat-autocomplete [displayWith]="displayUsuarios" #usuario="matAutocomplete">
                      <mat-option *ngFor="let s of filteredUsuariosList" [value]="s">
                        {{s.Nombre | uppercase}} {{s.Apellido | uppercase}} - {{s.Login}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
                <div fxFlex=45 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlPedidos">
                  <mat-form-field appearance="outline" style="width: 100%; color: white;">
                    <mat-label *ngIf="!isPedidoComunidadRolSearching">Rol en Pedidos</mat-label>
                    <mat-label *ngIf="isPedidoComunidadRolSearching">Cargando...</mat-label>
                    <mat-select formControlName="PedidoComunidadRol">
                      <mat-option>Ninguno</mat-option>
                      <mat-option *ngFor="let s of pedidoComunidadRolList" [value]="s">{{s.Nombre}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxFlex=10 fxFlex.xs=100 class="flex-item" style="margin-top:10px;" align="end">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <button mat-raised-button (click)="onUsuarioAdd()" [disabled]="isProcessing()" color="accent"
                      class="zb-button">Guardar</button>
                  </div>
                </div>

              </div>

            </form>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isUsuarioSearching">
              Cargando...
            </div>
            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isUsuarioSearching">
              <ejs-grid #usuarioGrid [dataSource]='item.Usuarios' [allowPaging]="true" [allowSorting]="true"
                [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                [allowResizing]='true'>
                <e-columns>
                  <e-column field='UsuarioLogin' headerText='Usuario' width=150></e-column>
                  <e-column field='PedidoComunidadRolNombre' headerText='Rol de Pedido' width=100 *ngIf="tenantFeatureFlags?.HabilitarControlPedidos"></e-column>
                  <e-column headerText='Acciones' width=90 *ngIf="canUserEdit">
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="onUsuarioDelete(data)"
                        title="Eliminar acceso de usuario"><i class="fa fa-trash fa-1x"></i></a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>

          </mat-expansion-panel>
        </ng-container>

        <!--SEGUROS EDIT-->
        <br/>
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">verified_user</mat-icon> Seguros
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="formSeguroGroup">

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Descripción*</mat-label>
                  <input matInput formControlName="Descripcion">
                  <mat-error style="margin-left: 3px;"
                    *ngIf="!formSeguroGroup.controls['Descripcion'].valid && formSeguroGroup.controls['Descripcion'].touched">
                    {{ getErrorSeguroDescripcion() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-top: 10px;">
                <a style="cursor: pointer; margin-right: 5px" href="{{formSeguroGroup.get('AdjuntoUrl')?.value}}" target="_blank"
                  *ngIf="formSeguroGroup?.get('AdjuntoUrl')?.value != null && formSeguroGroup?.get('AdjuntoUrl')?.value.length > 0">
                  Ver adjunto
                </a>
                <button mat-icon-button matSuffix (click)="seguroInput.click()" [disabled]="isFileAttaching">
                  <mat-icon style="margin-right: 5px;">attach_file</mat-icon> Adjuntar seguro
                </button>
                <input hidden (change)="onNewSeguroFileAttach($event)" #seguroInput type="file">
                <mat-label *ngIf="isFileAttaching"><br /><i class="fa fa-spinner fa-spin"></i> Subiendo archivo...
                </mat-label>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Vigencia Desde*</mat-label>
                  <input matInput [matDatepicker]="vigenciaDesdePicker" formControlName="VigenciaDesde"
                    (click)="vigenciaDesdePicker.open()">
                  <mat-error style="margin-left: 3px;"
                    *ngIf="!formSeguroGroup.controls['VigenciaDesde'].valid && formSeguroGroup.controls['VigenciaDesde'].touched">
                    {{ getErrorVigenciaDesde() }}
                  </mat-error>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="vigenciaDesdePicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle matSuffix (click)="clearVigenciaDesde()">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #vigenciaDesdePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Vigencia Hasta*</mat-label>
                  <input matInput [matDatepicker]="vigenciaHastaPicker" formControlName="VigenciaHasta"
                    (click)="vigenciaHastaPicker.open()">
                  <mat-error style="margin-left: 3px;"
                    *ngIf="!formSeguroGroup.controls['VigenciaHasta'].valid && formSeguroGroup.controls['VigenciaHasta'].touched">
                    {{ getErrorVigenciaHasta() }}
                  </mat-error>
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="vigenciaHastaPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker-toggle matSuffix (click)="clearVigenciaHasta()">
                    <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                  </mat-datepicker-toggle>
                  <mat-datepicker #vigenciaHastaPicker></mat-datepicker>
                </mat-form-field>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin-top:10px;" align="end">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <button mat-raised-button (click)="onSeguroAdd()" [disabled]="isProcessing()" color="accent"
                    class="zb-button">Guardar</button>
                </div>
              </div>

            </div>

          </form>

          <div fxLayout="row stretch" fxLayout.xs="column">
            <ejs-grid #seguroGrid [dataSource]='item.Seguros' [allowPaging]="true" [allowSorting]="true"
              [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
              [allowResizing]='true'>
              <e-columns>
                <e-column field='Descripcion' headerText='Descripción' width=150></e-column>
                <e-column field='VigenciaDesde' headerText='Desde' width=100 type="date" format="dd/MM/yyyy"></e-column>
                <e-column field='VigenciaHasta' headerText='Hasta' width=100 type="date" format="dd/MM/yyyy"></e-column>
                <e-column headerText='Acciones' width=90>
                  <ng-template #template let-data>
                    <a style="cursor: pointer; margin-right: 5px" href="{{data.AdjuntoUrl}}" target="_blank" title="Ver adjunto">
                      <i class="fa fa-file fa-1x"></i>
                    </a>
                    <a style="cursor: pointer; margin-right: 5px" (click)="onSeguroView(data)"
                      title="Ver seguro"><i class="fa fa-eye fa-1x"></i></a>
                    <a style="cursor: pointer; margin-right: 5px" (click)="onSeguroDelete(data)"
                      title="Eliminar seguro"><i class="fa fa-trash fa-1x"></i></a>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>
          </div>

        </mat-expansion-panel>

        <!--NUMEROS EMERGENCIA EDIT-->
        <br/>
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">perm_contact_calendar</mat-icon> Números de Emergencia
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>

          </mat-expansion-panel-header>

          <form [formGroup]="contactoEmergenciaFormGroup">

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=45 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Descripción*</mat-label>
                  <input matInput formControlName="Descripcion" (keyup.enter)="onNroEmergenciaAdd()" maxlength="200">
                  <mat-error
                    *ngIf="!contactoEmergenciaFormGroup.controls['Descripcion'].valid && contactoEmergenciaFormGroup.controls['Descripcion'].touched">
                    {{ getErrorDescripcion() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=45 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nro. Contacto*</mat-label>
                  <input matInput formControlName="NumeroContacto" (keyup.enter)="onNroEmergenciaAdd()" maxlength="100">
                  <mat-error
                    *ngIf="!contactoEmergenciaFormGroup.controls['NumeroContacto'].valid && contactoEmergenciaFormGroup.controls['NumeroContacto'].touched">
                    {{ getErrorNumeroContacto() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=10 fxFlex.xs=100 class="flex-item" style="margin-top:10px;" align="end">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <button mat-raised-button (click)="onNroEmergenciaAdd()" [disabled]="isProcessing()" color="accent"
                    class="zb-button">Agregar</button>
                </div>
              </div>

            </div>

          </form>

          <div fxLayout="row stretch" fxLayout.xs="column">
            <ejs-grid #grid [dataSource]='item.NumerosEmergencia' [allowPaging]="true" [allowSorting]="true"
              [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
              [allowResizing]='true'>
              <e-columns>
                <e-column field='Descripcion' headerText='Descripción' width=150></e-column>
                <e-column field='NumeroContacto' headerText='Número Contacto' width=100></e-column>
                <e-column headerText='Acciones' width=90>
                  <ng-template #template let-data>
                    <a style="cursor: pointer; margin-right: 5px" (click)="onNroEmergenciaDelete(data)"
                      title="Eliminar número emergencia"><i class="fa fa-trash fa-1x"></i></a>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>
          </div>

        </mat-expansion-panel>

        <!-- CUENTAS EDIT-->
        <!-- <ng-container *ngIf="canViewCuenta && item?.Id > 0">

          <br/>
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">account_balance_wallet</mat-icon> Cuentas
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>

            </mat-expansion-panel-header>

            <form [formGroup]="cuentaBancariaFormGroup" *ngIf="canAddCuenta || canEditCuenta">

              <div fxLayout="row stretch" fxLayout.xs="column">

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>CBU/CVU*</mat-label>
                    <input matInput formControlName="ClaveBancaria"  maxlength="100">
                    <mat-error
                      *ngIf="!cuentaBancariaFormGroup.controls['ClaveBancaria'].valid && cuentaBancariaFormGroup.controls['ClaveBancaria'].touched">
                      {{ getErrorClaveBancaria() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Alias*</mat-label>
                    <input matInput formControlName="Alias" maxlength="100">
                    <mat-error
                      *ngIf="!cuentaBancariaFormGroup.controls['Alias'].valid && cuentaBancariaFormGroup.controls['Alias'].touched">
                      {{ getErrorAlias() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isBancoSerching">Banco</mat-label>
                    <mat-label *ngIf="isBancoSerching">Cargando...</mat-label>
                    <mat-select formControlName="BancoId">
                      <mat-option *ngFor="let s of bancoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!cuentaBancariaFormGroup.controls['BancoId'].valid && cuentaBancariaFormGroup.controls['BancoId'].touched">
                      {{ getErrorBanco() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Nro. de Cuenta</mat-label>
                    <input matInput formControlName="NumeroCuenta" maxlength="100">
                    <mat-error
                      *ngIf="!cuentaBancariaFormGroup.controls['NumeroCuenta'].valid && cuentaBancariaFormGroup.controls['NumeroCuenta'].touched">
                      {{ getErrorNumeroCuenta() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Titular</mat-label>
                    <input matInput formControlName="Titular" maxlength="100">
                    <mat-error
                      *ngIf="!cuentaBancariaFormGroup.controls['Titular'].valid && cuentaBancariaFormGroup.controls['Titular'].touched">
                      {{ getErrorTitular() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isMonedaSearching">Moneda*</mat-label>
                    <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                    <mat-select formControlName="MonedaId">
                      <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!cuentaBancariaFormGroup.controls['MonedaId'].valid && cuentaBancariaFormGroup.controls['MonedaId'].touched">
                      {{ getErrorMoneda() }}
                    </mat-error>
                  </mat-form-field>
                </div>

                <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px 0;" align="end">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <button mat-raised-button (click)="onCuentaSave()" [disabled]="isProcessing()" color="primary"
                      class="zb-button">Guardar Cuenta</button>
                  </div>
                </div>

              </div>

            </form>

            <div fxLayout="row stretch" fxLayout.xs="column">
              <ejs-grid #cuentasGrid [dataSource]='item.Cuentas' [allowPaging]="true" [allowSorting]="true"
                [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                [allowResizing]='true'>
                <e-columns>
                  <e-column field='BancoNombre' headerText='Banco' width=100></e-column>
                  <e-column field='NumeroCuenta' headerText='Nro. Cuenta' width=100></e-column>
                  <e-column field='ClaveBancaria' headerText='CBU/CVU' width=100></e-column>
                  <e-column field='Alias' headerText='Alias' width=150></e-column>
                  <e-column field='MonedaCodigo' headerText='Moneda' width=100></e-column>
                  <e-column headerText='Acciones' width=90 *ngIf="canEditCuenta || canDeleteCuenta">
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="onCuentaView(data)" *ngIf="canEditCuenta"
                        title="Ver cuenta"><i class="fa fa-eye fa-1x"></i>
                      </a>
                      <a style="cursor: pointer; margin-right: 5px" (click)="onCuentaDelete(data)" *ngIf="canDeleteCuenta"
                        title="Eliminar cuenta"><i class="fa fa-trash fa-1x"></i>
                      </a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>

          </mat-expansion-panel>

        </ng-container> -->

        <!--TIPO GASTOS EDIT-->
        <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlGastos">
          <br/>
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">attach_money</mat-icon> Tipos de Gastos
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <form [formGroup]="tiposGastosFormGroup" *ngIf="canEdit">

              <div fxLayout="row stretch" fxLayout.xs="column">

                <div fxFlex=45 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label *ngIf="!isTiposGastosSearching && !isComunidadTiposGastosSearching">Tipo de Gasto</mat-label>
                    <mat-label *ngIf="isTiposGastosSearching || isComunidadTiposGastosSearching">Cargando...</mat-label>
                    <mat-select formControlName="TipoGastoId">
                      <mat-option *ngFor="let s of tiposGastosList" [value]="s.Id">{{s.Nombre}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="!tiposGastosFormGroup.controls['TipoGastoId'].valid && tiposGastosFormGroup.controls['TipoGastoId'].touched">
                      {{ getErrorTipoGastoId() }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex=45 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center" style="margin-top: 15px;" *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
                  <!-- <mat-form-field appearance="outline" style="width: 100%"> -->
                    <mat-checkbox formControlName="MostrarEnResumenExpensa">Mostrar el gasto en las columnas de expensas</mat-checkbox>
                  <!-- </mat-form-field> -->
                </div>
                <div fxFlex=10 fxFlex.xs=100 class="flex-item" style="margin-top:10px;" align="end">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <button mat-raised-button (click)="onTipoGastoAdd()" [disabled]="isProcessing()" color="accent"
                      class="zb-button">Agregar</button>
                  </div>
                </div>

              </div>

            </form>

            <div fxLayout="row stretch" fxLayout.xs="column">
              <ejs-grid #tiposGastosGrid [dataSource]='item.TiposGastos' [allowPaging]="true" [allowSorting]="true"
                [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                [allowResizing]='true'>
                <e-columns>
                  <e-column field='TipoGasto' headerText='Tipo Gasto' width="200"></e-column>
                  <e-column field='MostrarEnResumenExpensa' headerText='Mostrar en Expensas' width="70" *ngIf="tenantFeatureFlags?.HabilitarControlExpensas">
                    <ng-template #template let-data>
                      {{data.MostrarEnResumenExpensa ? 'Sí' : 'No'}}
                    </ng-template>
                  </e-column>
                  <e-column headerText='Acciones' width="70" *ngIf="canEdit">
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="onTipoGastoDelete(data)"
                        title="Eliminar tipo de gasto"><i class="fa fa-trash fa-1x"></i></a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>

          </mat-expansion-panel>
        </ng-container>

        <!--MAPA EDIT: habilitar en algun momento-->
        <ng-container *ngIf="false">

          <br/>
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">place</mat-icon>Mapa
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div fxLayout="row stretch" fxLayout.xs="column">
              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <agm-map #map [center]="[lat, lng]" [latitude]="lat" [longitude]="lng" [zoom]="zoom"
                  [mapTypeId]="mapTypeId" (mapClick)="markObraPosition($event)">
                  <agm-marker *ngIf="usuarioLocated" [latitude]="usuarioMarker.lat" [longitude]="usuarioMarker.lng"
                    [markerDraggable]="true">
                    <agm-info-window>
                      Mi ubicación (aprox)
                    </agm-info-window>
                  </agm-marker>
                  <agm-marker *ngIf="obraLocated" [latitude]="obraMarker.lat" [longitude]="obraMarker.lng"
                    [markerDraggable]="obraMarker.draggable" (dragEnd)="onMarkerDragEnd($event)">
                    <agm-info-window>
                      {{item.Nombre}}
                    </agm-info-window>
                  </agm-marker>
                  <agm-marker *ngIf="item.Id == 0 && obraLocated" [latitude]="obraMarker.lat" [longitude]="obraMarker.lng"
                    [markerDraggable]="obraMarker.draggable" (dragEnd)="onMarkerDragEnd($event)">
                    <agm-info-window>
                      {{formGroup.value.Nombre}}
                    </agm-info-window>
                  </agm-marker>
                </agm-map>
              </div>

            </div>
            <div fxLayout="row" fxLayoutGap="10px" style="margin: 10px 0px;">
              <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                <button mat-raised-button (click)="getObraPosition()"
                  [disabled]="isProcessing() || obraMarker == undefined" color="primary" class="zb-button">{{isSaving ?
                  'Buscando...' : 'Ir a ubicación marcada'}}</button>
                <button mat-raised-button (click)="deleteObraPosition()" color="warn" class="zb-button">{{canEdit ?
                  'Eliminar ubicación' :
                  'Cerrar'}}</button>
              </div>
              <div fxLayout="row" fxLayoutAlign="end center" style="flex-grow: 1;">
                <button mat-raised-button (click)="getCurrentPosition()" [disabled]="isProcessing()"
                  class="zb-button">{{isSaving ? 'Buscando...' : 'Ir a mi ubicación actual'}}</button>
              </div>
            </div>
          </mat-expansion-panel>

        </ng-container>

      </ng-container>

      <ng-container *ngIf="!canEdit">

        <!--INFO GENERAL READONLY-->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos Generales
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" class="zb-readonly">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="Center" *ngIf="!comunidadImageChanged()">
              <a target="_blank" href="{{item?.FotoPerfilUrl}}">
                <img src="{{item?.FotoPerfilUrl}}" style="height: 100px; width: 100px; border-radius: 100%;">
              </a>
            </div>
            <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="Center" *ngIf="comunidadImageChanged()">
              <img src="{{comunidadImageBase64}}"
                style="height: 100px; width: 100px; border-radius: 100%; margin-bottom: 10px;">
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nombre</b>: {{item.Nombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>{{ 'TipoComunidad' | translate}}</b>: {{item.TipoNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item"  *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>{{ 'Consorcio' | translate}}</b>: {{item.ConsorcioNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Cantidad de Pisos</b>: {{item.CantidadPisos}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Fecha Construcción</b>: {{item.FechaConstruccion | date:'dd/MM/yyyy'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Dirección</b>: {{item.Direccion}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Código Postal</b>: {{item.CodigoPostal}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Categoría SUTERH</b>: {{item.CategoriaSuterhNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarGestionConsorcio">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Clave SUTERH</b>: {{item.ClaveSuterh}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Observaciones</b>: {{item.Observaciones}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <!--DATOS ESTRICTAMENTE DE OBRAS-->
            <ng-container *ngIf="tenantFeatureFlags?.HabilitarGestionObra">
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Contratista Principal</b>: {{item.ContratistaPrincipal}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Ejecutiva de Obra</b>: {{item.EjecutivaObra}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>M<sup>2</sup> de {{'Comunidad' | translate}}</b>: {{item.M2Obra}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Tipo de contrato</b>: {{item.TipoContratoNombre}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Director de obra</b>: {{item.DirectorObra}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Estudio proyectista</b>: {{item.EstudioProyectista}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Estudio calculista</b>: {{item.EstudioCalculista}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label><b>Representante técnico</b>: {{item.RepresentanteTecnico}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
            </ng-container>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <hr style="margin:20px 0px; width: 100%;">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="canViewPuntoEq">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Punto de Equilibrio</b>: {{item.PuntoEquilibrio | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

        <!--ADJUNTOS READONLY-->
        <br />
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">attach_file</mat-icon> Adjuntos
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" class="zb-readonly">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="isAttachmentSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>
            <ejs-grid #adjuntosGrid [dataSource]='item.Adjuntos' [allowPaging]="true" [allowSorting]="true"
              [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
              [allowResizing]='true' *ngIf="!isAttachmentSearching">
              <e-columns>
                <e-column field='Descripcion' headerText='Descripción' width=80></e-column>
                <e-column field='UrlDocumento' headerText='Adjunto'>
                  <ng-template #template let-data>
                    <a matLine href="{{data.UrlDocumento}}" target="_blank">{{data.NombreDocumento}}</a>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>

          </div>

        </mat-expansion-panel>

        <!--USUARIOS READONLY-->
        <ng-container *ngIf="canUserView">
          <br/>
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">lock_open</mat-icon> Usuarios Habilitados
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isUsuarioSearching">
              Cargando...
            </div>
            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isUsuarioSearching">
              <ejs-grid #usuarioGrid [dataSource]='item.Usuarios' [allowPaging]="true" [allowSorting]="true"
                [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                [allowResizing]='true'>
                <e-columns>
                  <e-column field='UsuarioLogin' headerText='Usuario' width=150></e-column>
                  <e-column field='PedidoComunidadRolNombre' headerText='Rol de Pedido' width=100 *ngIf="tenantFeatureFlags?.HabilitarControlPedidos"></e-column>
                </e-columns>
              </ejs-grid>
            </div>

          </mat-expansion-panel>
        </ng-container>

        <!--SEGUROS READONLY-->
        <br />
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">verified_user</mat-icon> Seguros
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column">
            <ejs-grid #seguroGrid [dataSource]='item.Seguros' [allowPaging]="true" [allowSorting]="true"
              [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
              [allowResizing]='true'>
              <e-columns>
                <e-column field='Descripcion' headerText='Descripción' width=150></e-column>
                <e-column field='VigenciaDesde' headerText='Desde' width=100 type="date" format="dd/MM/yyyy"></e-column>
                <e-column field='VigenciaHasta' headerText='Hasta' width=100 type="date" format="dd/MM/yyyy"></e-column>
                <e-column headerText='Acciones' width=90>
                  <ng-template #template let-data>
                    <a  style="cursor: pointer; margin-right: 5px" href="{{file.AdjuntoUrl}}" target="_blank" title="Ver adjunto">
                      <i class="fa fa-file fa-1x"></i>
                    </a>
                    <a style="cursor: pointer; margin-right: 5px" (click)="onSeguroFileAttachedDelete(data)"
                      title="Eliminar seguro"><i class="fa fa-trash fa-1x"></i></a>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>
          </div>

        </mat-expansion-panel>

        <!--NUMEROS EMERGENCIA READONLY-->
        <br/>
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">perm_contact_calendar</mat-icon> Números de Emergencia
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" class="zb-readonly">
            <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="margin:10px;" *ngIf="isNumerosEmergenciaSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>
            <ejs-grid #grid [dataSource]='item.NumerosEmergencia' [allowPaging]="true" [allowSorting]="true"
              [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
              [allowResizing]='true' *ngIf="!isNumerosEmergenciaSearching">
              <e-columns>
                <e-column field='Descripcion' headerText='Descripción' width=150></e-column>
                <e-column field='NumeroContacto' headerText='Número Contacto' width=100></e-column>
              </e-columns>
            </ejs-grid>
          </div>

        </mat-expansion-panel>

        <!-- CUENTAS READONLY -->
        <!-- <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlCaja && canViewCuenta">

          <br/>
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">account_balance_wallet</mat-icon> Cuentas
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>

            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">
              <ejs-grid #cuentasGrid [dataSource]='item.Cuentas' [allowPaging]="true" [allowSorting]="true"
                [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                [allowResizing]='true'>
                <e-columns>
                  <e-column field='BancoNombre' headerText='Banco' width=100></e-column>
                  <e-column field='NumeroCuenta' headerText='Nro. Cuenta' width=100></e-column>
                  <e-column field='ClaveBancaria' headerText='CBU/CVU' width=100></e-column>
                  <e-column field='Alias' headerText='Alias' width=150></e-column>
                  <e-column field='MonedaCodigo' headerText='Moneda' width=100></e-column>
                  <e-column headerText='Acciones' width=90 *ngIf="canEditCuenta || canDeleteCuenta">
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="onCuentaView(data)" *ngIf="canEditCuenta"
                        title="Ver cuenta"><i class="fa fa-eye fa-1x"></i>
                      </a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>

          </mat-expansion-panel>

        </ng-container> -->

        <!--TIPO DE GASTOS READONLY-->
        <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlGastos">
          <br/>
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">attach_money</mat-icon> Tipos de Gastos
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" class="zb-readonly">
              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label *ngIf="isComunidadTiposGastosSearching">Cargando...</mat-label>
                    <mat-label *ngIf="!isComunidadTiposGastosSearching"><b>Tipos de Gastos Asociados</b>:
                      {{tiposGastosString}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
            </div>

          </mat-expansion-panel>
        </ng-container>

        <!--MAPA READONLY: habilitar en algun momento-->
        <ng-container *ngIf="false">

          <br/>
          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">place</mat-icon>Mapa
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div fxLayout="row stretch" fxLayout.xs="column">
              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <agm-map #map [center]="[lat, lng]" [latitude]="lat" [longitude]="lng" [zoom]="zoom"
                  [mapTypeId]="mapTypeId" (mapClick)="markObraPosition($event)">
                  <agm-marker *ngIf="obraLocated" [latitude]="obraMarker.lat" [longitude]="obraMarker.lng"
                    [markerDraggable]="obraMarker.draggable" (dragEnd)="onMarkerDragEnd($event)">
                    <agm-info-window>
                      {{item.Nombre}}
                    </agm-info-window>
                  </agm-marker>
                </agm-map>
              </div>
            </div>
          </mat-expansion-panel>

        </ng-container>

      </ng-container>

      <ng-container *ngIf="item != null && item.Id > 0 && canViewIncidencias">

        <br/>

        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">error</mat-icon> Incidencias Asociadas
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item">

              <mat-label *ngIf="isIncidenciasSearching">Buscando...</mat-label>
              <ejs-grid #gridIncidencias [dataSource]='incidenciasList' [allowPaging]="true"
                [allowSorting]="true" *ngIf="!isIncidenciasSearching" [selectionSettings]='selectionOptions'
                [pageSettings]='pageSettings' [allowResizing]='true'>
                <e-columns>
                  <e-column field='Id' headerText='#' width=60></e-column>
                  <e-column field='FechaUltimoMensaje' headerText='Fecha Ult. Actualización' type="Date" format="dd/MM/yyyy HH:mm" width=60></e-column>
                  <e-column field='IncidenciaUsuarioCategoriaNombre' headerText='Categoría' width=90></e-column>
                  <e-column field='ProveedorNombre' headerText='Proveedor' width=90></e-column>
                  <e-column field='EstadoNombre' headerText='Estado' width=90></e-column>
                  <e-column field='Asunto' headerText='Asunto' width=120></e-column>
                  <e-column headerText='Acciones' width=40>
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 18px" (click)="viewIncidencia(data.Id)">
                        <mat-icon style="width: 5px; font-size: 18px;" title="Ver incidencia">visibility</mat-icon>
                      </a>
                    </ng-template>
                  </e-column>

                </e-columns>
              </ejs-grid>

            </div>

          </div>

        </mat-expansion-panel>

      </ng-container>

      <ng-container *ngIf="item != null && item.Id > 0 && canViewSaldos">

        <br/>

        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-right: 5px;">monetization_on</mat-icon> Resumen de Saldos
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;" *ngIf="isSaldosSearching">
            <mat-label>Buscando...</mat-label>
          </div>

          <ng-container *ngIf="!isSaldosSearching">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" *ngIf="saldosList == null || saldosList.length == 0" >
              <mat-label>No hay saldos para mostrar.</mat-label>
            </div>

            <ng-container *ngIf="saldosList != null && saldosList.length > 0">

              <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin-top: 10px;" *ngFor="let saldo of saldosList" >

                <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label>
                        <b>Saldo Total</b>:
                        <span style="margin-left: 5px;" [ngStyle]="{ color: (saldo.SaldoTotal < 0) ? 'indianred' : 'black' }">{{saldo.Moneda}} {{saldo.SaldoTotal | number: '1.2-2'}}</span>
                      </mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Saldo A Favor</b>: {{saldo.Moneda}} {{saldo.SaldoAFavor | number:'1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Saldo Deudor</b>: {{saldo.Moneda}} {{saldo.SaldoDeudor | number:'1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>
                <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                  <mat-expansion-panel [expanded]="true" hideToggle="true">
                    <div fxLayout="row stretch" fxLayout.xs="column">
                      <mat-label><b>Saldo Vencido</b>: {{saldo.Moneda}} {{saldo.SaldoVencido | number:'1.2-2'}}</mat-label>
                    </div>
                  </mat-expansion-panel>
                </div>

              </div>

            </ng-container>

          </ng-container>

        </mat-expansion-panel>

      </ng-container>

    </div>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row stretch" fxLayout.xs="column">
      <button mat-raised-button (click)="onGuardar()" *ngIf="canEdit" [disabled]="isProcessing()" color="primary"
        class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
      <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">{{canAdd || canEdit ? 'Cancelar' :
        'Cerrar'}}</button>
      <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && item != null && item.Id > 0" [disabled]="isProcessing()" color="secondary" class="zb-button">
        {{ isDeleting ? 'Eliminando...' : 'Eliminar' }}
      </button>
    </div>
  </mat-card-actions>

</mat-card>
